export const SET_INITIAL_MY_FLOW_STORE_DATA = 'SET_INITIAL_MY_FLOW_STORE_DATA';

export const REMOVE_ITEM_FROM_MYLOFW = 'REMOVE_ITEM_FROM_MYLOFW';
export const ADD_ITEM_TO_MYLOFW = 'ADD_ITEM_TO_MYLOFW';

export const REQUESTING_FB_AUTH_ID = 'REQUESTING_FB_AUTH_ID';
export const SET_FB_AUTH_ID = 'SET_FB_AUTH_ID';
export const UNSET_FB_AUTH_ID = 'UNSET_FB_AUTH_ID';

export const SET_FETCHED_USER_TIMETABLE = 'SET_FETCHED_USER_TIMETABLE';
export const ARTIST_UPDATED = 'ARTIST_UPDATED';
export const USER_TIMETABLE_SAVED = 'USER_TIMETABLE_SAVED';

export const SET_MY_FLOW = 'SET_MY_FLOW';

// For my flow guest appearances
export const SET_USER_LIST_TIMETABLE = 'SET_USER_LIST_TIMETABLE';
export const LOADING_USER_LIST_TIMETABLE = 'LOADING_USER_LIST_TIMETABLE';

export const localStorageMyFlowToken = 'my-flow';


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/myflow/constants.ts